import _ from 'lodash';
import api from './alice-api';

// const defaultIsHide = false;
const defaultConfig = {
  understanding: {
    isHide: true
  },
  satisfaction: {
    isHide: true
  },
  knowledge: {
    modelSetting: {
      isHide: true
    },
    rulebased: {
      isHide: true
    },
    nlpConfig: {
      isHide: true
    },
    files: {
      isHide: true
    },
    isHide: true
  },
  oneOnOneChat: {
    isHide: true,
    chatMode: {
      isHide: true
    }
  },
  tools: {
    valueEditor: {
      isHide: true
    },
    exportChatLogs: {
      isHide: true
    },
    exportFaqReport: {
      isHide: true
    },
    promotions: {
      isHide: true
    },
    exportPromotionTracking: {
      isHide: true
    },
    isHide: true
  },
  setting: {
    userManager: {
      isHide: true
    },
    isHide: true
  },
  activitylog: {
    isHide: true
  },
  nps: {
    isHide: true
  },
  generativeAIUsage: {
    isHide: true
  },
  lineBroadcast: {
    isHide: true,
  },
};

let clientConfig = {};
// clientConfig.understanding = { isHide: process.env.VUE_APP_HIDE_MENU_UNDERSTANDING ? process.env.VUE_APP_HIDE_MENU_UNDERSTANDING === 'true' : defaultIsHide };
//
// clientConfig.satisfaction = { isHide: process.env.VUE_APP_HIDE_MENU_SATISFACTION ? process.env.VUE_APP_HIDE_MENU_SATISFACTION === 'true' : defaultIsHide };
//
// clientConfig.knowledge = {};
// clientConfig.knowledge.modelSetting = { isHide: process.env.VUE_APP_HIDE_MENU_KNOWLEDGE__MODEL_SETTING ? process.env.VUE_APP_HIDE_MENU_KNOWLEDGE__MODEL_SETTING === 'true' : defaultIsHide };
// clientConfig.knowledge.rulebased = { isHide: process.env.VUE_APP_HIDE_MENU_KNOWLEDGE__RULEBASED ? process.env.VUE_APP_HIDE_MENU_KNOWLEDGE__RULEBASED === 'true' : defaultIsHide };
// clientConfig.knowledge.nlpConfig = { isHide: process.env.VUE_APP_HIDE_MENU_KNOWLEDGE__NLP_CONFIG ? process.env.VUE_APP_HIDE_MENU_KNOWLEDGE__NLP_CONFIG === 'true' : defaultIsHide };
// clientConfig.knowledge.isHide = clientConfig.knowledge.modelSetting.isHide && clientConfig.knowledge.rulebased.isHide && clientConfig.knowledge.nlpConfig.isHide;
//
// clientConfig.oneOnOneChat = { isHide: process.env.VUE_APP_HIDE_MENU_ONEONONE_CHAT ? process.env.VUE_APP_HIDE_MENU_ONEONONE_CHAT === 'true' : defaultIsHide };
// clientConfig.oneOnOneChat.chatMode = { isHide: process.env.VUE_APP_HIDE_CHAT_MODE ? process.env.VUE_APP_HIDE_CHAT_MODE === 'true' : defaultIsHide };
//
// clientConfig.tools = {};
// clientConfig.tools.valueEditor = { isHide: process.env.VUE_APP_HIDE_MENU_TOOLS__VALUE_EDITOR ? process.env.VUE_APP_HIDE_MENU_TOOLS__VALUE_EDITOR === 'true' : defaultIsHide };
// clientConfig.tools.exportChatLogs = { isHide: process.env.VUE_APP_HIDE_MENU_TOOLS__EXPORT_CHAT_LOGS ? process.env.VUE_APP_HIDE_MENU_TOOLS__EXPORT_CHAT_LOGS === 'true' : defaultIsHide };
// clientConfig.tools.promotions = { isHide: process.env.VUE_APP_HIDE_MENU_TOOLS__PROMOTIONS ? process.env.VUE_APP_HIDE_MENU_TOOLS__PROMOTIONS === 'true' : defaultIsHide };
// clientConfig.tools.isHide = clientConfig.tools.valueEditor.isHide && clientConfig.tools.exportChatLogs.isHide && clientConfig.tools.promotions.isHide;
//
// clientConfig.setting = {};
// clientConfig.setting.userManager = { isHide: process.env.VUE_APP_HIDE_MENU_SETTING__USER_MANAGER ? process.env.VUE_APP_HIDE_MENU_SETTING__USER_MANAGER === 'true' : defaultIsHide };
// clientConfig.setting.isHide = clientConfig.setting.userManager.isHide;
//
// clientConfig.activitylog = { isHide: process.env.VUE_APP_HIDE_MENU_ACTIVITY_LOG ? process.env.VUE_APP_HIDE_MENU_ACTIVITY_LOG === 'true' : defaultIsHide };
// clientConfig.nps = { isHide: process.env.VUE_APP_HIDE_MENU_NPS ? process.env.VUE_APP_HIDE_MENU_NPS === 'true' : defaultIsHide };

let isCalled = false;
const loadServerConfig = async () => {
  if (isCalled === false) {
    const serverConfig = await api.getServerDashboardConfig();
    clientConfig = _.cloneDeep(serverConfig.data);
    isCalled = true;
  }
  return clientConfig;
};

// eslint-disable-next-line no-return-await
const getConfig = async () => await loadServerConfig();

const getDefaultClientConfig = () => defaultConfig;

export default { getConfig, getDefaultClientConfig };
